import { render, staticRenderFns } from "./SalonNewHistory.vue?vue&type=template&id=b2354d1c&scoped=true&"
import script from "./SalonNewHistory.vue?vue&type=script&lang=js&"
export * from "./SalonNewHistory.vue?vue&type=script&lang=js&"
import style0 from "./SalonNewHistory.vue?vue&type=style&index=0&id=b2354d1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2354d1c",
  null
  
)

export default component.exports